import { FC } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_theme/helpers";
import { envConfig } from "../../../utils/config";

type Props = {
    pdf: string;
    logo: string;
    logoAlt: string;
    children?: React.ReactNode;
};

const InfrastructureHero: FC<Props> = ({
    pdf,
    logo,
    logoAlt,
    children,
}) => {
    return (
        <div className="position-relative vh-100 overflow-hidden">
            <img
                src={toAbsoluteUrl("media/images/aboutsdepartment.jpg")}
                alt={logoAlt}
                className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
                loading="eager"
            />

            <div className="position-absolute top-50 start-50 translate-middle w-100 text-center text-white px-3">
                <div className="public-pages-container d-flex flex-column align-items-center">

                    <div className="wcifbox">
                        <Link
                            to={envConfig.APP_MEDIA_URL + pdf}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={toAbsoluteUrl(logo)}
                                alt={logoAlt}
                                className="img-fluid"
                                loading="eager"
                            />
                        </Link>
                    </div>

                    {children}
                </div>
            </div>
        </div>
    );
};

export default InfrastructureHero;